<script setup lang="ts">
import ConfirmDialog from 'primevue/confirmdialog'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/shared/stores/AuthStore'

const route = useRoute()
const { isUserAuthenticated } = storeToRefs(useAuthStore())

/*
 * Layout selection: a page can force a layout via `definePage({ meta: { layout } })` (e.g. the
 * login page uses 'empty'); otherwise the authenticated app shell is shown once logged in.
 */
const layout = computed(() => route.meta.layout ?? (isUserAuthenticated.value ? 'default' : 'empty'))
</script>

<template>
  <ConfirmDialog />
  <Toast position="bottom-right" />
  <Default v-if="layout === 'default'">
    <suspense>
      <router-view />
    </suspense>
  </Default>
  <div v-else>
    <suspense>
      <router-view />
    </suspense>
  </div>

  <DynamicDialog append-to="body" />
</template>

<style>
@import "@/assets/sass/app.scss";
</style>
